<div>
  <div class="text-center">
    <fileupload (change)="onFilesChange($event)" [message]="filesMsg" [files]="files" class="blue"></fileupload>
  </div>

  <div class="mt-10">
    <gmt-button [clickAction]="onSubmit" [gmtDisabled]="!isFileValidToUpload">Spustit validaci souboru</gmt-button>
  </div>
</div>
